import type { AdmissionPriceProps } from './calculate-booking-price.type';

export const calculateAdmissionPrice = ({ offer, quantity }: AdmissionPriceProps) => {
  if (!offer) return 0;
  let number = 0;
  number += offer.price.amount * quantity;
  return number;
};
